"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _material = require("@mui/material");

var _Icon = require("../Icon");

var _Typography = require("../Typography");

var _theme = require("../../theme");

var _utilities = require("../../utilities");

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledButtonBase = (0, _material.styled)(_material.ButtonBase, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "selected";
  }
})(function (_ref) {
  var _ref2;

  var theme = _ref.theme,
      selected = _ref.selected;
  return _ref2 = {}, (0, _defineProperty2.default)(_ref2, "&.".concat(_utilities.classes.states.MuiDisabled), {
    "& > *": {
      color: theme.palette.brand.grey.grey
    },
    color: theme.palette.action.disabled,
    opacity: theme.palette.action.disabledOpacity
  }), (0, _defineProperty2.default)(_ref2, "&.".concat(_utilities.classes.states.MuiFocusVisible), {
    backgroundColor: theme.palette.primary.light
  }), (0, _defineProperty2.default)(_ref2, "&:hover", {
    backgroundColor: theme.palette.primary.light
  }), (0, _defineProperty2.default)(_ref2, "backgroundColor", selected ? theme.palette.primary.light : "initial"), (0, _defineProperty2.default)(_ref2, "border", selected ? "1px solid ".concat(theme.palette.primary.main) : "initial"), (0, _defineProperty2.default)(_ref2, "borderRadius", theme.shape.borderRadius), (0, _defineProperty2.default)(_ref2, "boxSizing", "border-box"), (0, _defineProperty2.default)(_ref2, "color", selected ? theme.palette.primary.main : theme.palette.text.primary), (0, _defineProperty2.default)(_ref2, "height", theme.spacing(5)), (0, _defineProperty2.default)(_ref2, "margin", "0 0.188rem"), (0, _defineProperty2.default)(_ref2, "minWidth", theme.spacing(5)), (0, _defineProperty2.default)(_ref2, "padding", "0 0.375rem"), (0, _defineProperty2.default)(_ref2, "textAlign", "center"), (0, _defineProperty2.default)(_ref2, "transition", theme.transitions.create(["color", "background-color"], {
    duration: theme.transitions.duration.short
  })), _ref2;
});
var StyledTypography = (0, _material.styled)(_Typography.Typography, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "type";
  }
})(function (_ref3) {
  var theme = _ref3.theme,
      type = _ref3.type;
  return {
    color: theme.palette.primary.main,
    marginLeft: type === "first" ? theme.spacing(1) : theme.spacing(0),
    marginRight: type === "last" ? theme.spacing(1) : theme.spacing(0),
    textTransform: "capitalize"
  };
});
var StyledDiv = (0, _material.styled)("div")(function (_ref4) {
  var _ref5;

  var theme = _ref4.theme;
  return _ref5 = {}, (0, _defineProperty2.default)(_ref5, "&.".concat(_utilities.classes.states.MuiDisabled), {
    opacity: theme.palette.action.disabledOpacity
  }), (0, _defineProperty2.default)(_ref5, "borderRadius", 32 / 2), (0, _defineProperty2.default)(_ref5, "boxSizing", "border-box"), (0, _defineProperty2.default)(_ref5, "color", theme.palette.text.primary), (0, _defineProperty2.default)(_ref5, "height", "auto"), (0, _defineProperty2.default)(_ref5, "margin", "0 0.188rem"), (0, _defineProperty2.default)(_ref5, "minWidth", theme.spacing(5)), (0, _defineProperty2.default)(_ref5, "padding", "0 0.375rem"), (0, _defineProperty2.default)(_ref5, "textAlign", "center"), _ref5;
});
var icons = {
  first: "backward",
  last: "forward",
  next: "caret-right",
  previous: "caret-left"
};

var PaginationItem = function PaginationItem(_ref6) {
  var getAriaLabel = _ref6.getAriaLabel,
      item = _ref6.item,
      labels = _ref6.labels;
  var page = item.page,
      type = item.type,
      selected = item.selected,
      disabled = item.disabled,
      onClick = item.onClick;
  var isEllipsis = type === "start-ellipsis" || type === "end-ellipsis";
  var icon = icons[type];
  var ariaLabel = getAriaLabel(item);

  var labelsIndexed = _objectSpread({}, labels);

  var items = icon ? [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTypography, {
    "aria-hidden": "true",
    component: "span",
    type: type,
    variant: "body2",
    children: labelsIndexed[type]
  }, type), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
    color: disabled ? _theme.palette.brand.grey.grey : _theme.palette.primary.main,
    iconName: icon,
    style: type === "next" || type === "previous" ? {
      fontSize: "1rem"
    } : {
      fontSize: "0.7rem"
    }
  }, icon)] : [];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
    children: isEllipsis ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledDiv, {
      children: "..."
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledButtonBase, {
      "aria-label": ariaLabel,
      "data-testid": type === "page" ? "page ".concat(page) : type,
      disableRipple: true,
      disableTouchRipple: true,
      disabled: disabled,
      onClick: onClick,
      selected: selected,
      children: [(type === "first" || type === "previous") && items.reverse().map(function (item) {
        return item;
      }), (type === "next" || type === "last") && items.map(function (item) {
        return item;
      }), type === "page" && page]
    })
  });
};

var _default = PaginationItem;
exports.default = _default;